import { controls,grouped } from "../controls";
const societies = {
label: "Societies",
pageLabel: "Societies",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
formTabs:
 {allTabs: [
{ label: "General", uid: "general" },
{label: "Address",uid: "address"}
]},
filter:[
...controls.displayText({ tab: "filter", label: "Code"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "society_code",maxlength:10}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Description",description:'Starting partial search. e.g. You can search for Sugar Cane by typing sugar.'}),
...controls.text({ tab: "filter",  placeHolder: "", name: "society_display",maxlength:50}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Member"}),
...controls.oc({ tab: "filter", c: "Member", placeHolder: "Member", name: "Society-chairman_member-member",fastpath:"members"}),
...controls.showData({ tab: "filter", displaytype: "capital", data: "Society-chairman_member-member"}),
...controls.displayText({ tab: "filter", label: "Employee"}),
...controls.oc({ tab: "filter", c: "Employee", placeHolder: "Employee Code", name: "Society-secretary_employee-employee_code",fastpath:"hr15"}),
...controls.showData({ tab: "filter", displaytype: "capital", data: "Society-secretary_employee-employee_display"}),
]
,form:[
...controls.displayText({ tab: "general", label: "Code",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "society_code",isRequired:true,maxlength:10}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Description",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "society_display",isRequired:true,maxlength:50}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Metro Type",star:false}),
...controls.oc({ tab: "general", c: "MetroType", placeHolder: "Metro Type Code", name: "metro_type_code", isRequired:false,fastpath:"metro_types",autoopen:true}),
...controls.showData({ tab: "general", displaytype: "capital", data: "metro_type_display"}),
...controls.magicDateLabel({ tab: "general", label: "Open Date",target: "open_date",star:false}),
...controls.magicDate({ tab: "general", name: "open_date", dateType: "ontype",isRequired:false }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.magicDateLabel({ tab: "general", label: "Close Date",target: "close_date",star:false}),
...controls.magicDate({ tab: "general", name: "close_date", dateType: "ontype",isRequired:false }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Member",star:false}),
...controls.oc({ tab: "general", c: "Member", placeHolder: "Member", name: "member_code", isRequired:false,fastpath:"members"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "member_display"}),
...controls.displayText({ tab: "general", label: "Employee",star:false}),
...controls.oc({ tab: "general", c: "Employee", placeHolder: "Employee Code", name: "employee_code", isRequired:false,fastpath:"hr15"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "employee_display"}),
...controls.displayText({ tab: "general", label: "Address",star:false}),
...controls.oc({ tab: "general", c: "Address", placeHolder: "Address Code", name: "address_code", isRequired:false,fastpath:"address"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "address_display"}),
...controls.checkBox({ tab: "general", label: "Active",default:false, name: "society_active" }),
...controls.displayText({ tab: "address", label: "Line 1",star:false}),
...controls.text({ tab: "address",  placeHolder: "", name: "address.line_1",isRequired:false,width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "address", label: "Line 2",star:false}),
...controls.text({ tab: "address",  placeHolder: "", name: "address.line_2",isRequired:false,width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "address", label: "Line 3",star:false}),
...controls.text({ tab: "address",  placeHolder: "", name: "address.line_3",isRequired:false,width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "address", label: "Village",star:true}),
...controls.oc({ tab: "address", c: "Village", placeHolder: "Village Code", name: "address.village_code", isRequired:true,fastpath:"villages"}),
...controls.showData({ tab: "address", displaytype: "capital", data: "address.village_display"}),
...controls.displayText({ tab: "address", label: "Taluka",star:true}),
...controls.oc({ tab: "address", c: "Taluka", placeHolder: "Taluka Code", name: "address.taluka_code", isRequired:true,fastpath:"talukas"}),
...controls.showData({ tab: "address", displaytype: "capital", data: "address.taluka_display"}),
...controls.displayText({ tab: "address", label: "District",star:true}),
...controls.oc({ tab: "address", c: "District", placeHolder: "District Code", name: "address.district_code", isRequired:true,fastpath:"districts"}),
...controls.showData({ tab: "address", displaytype: "capital", data: "address.district_display"}),
...controls.displayText({ tab: "address", label: "State",star:true}),
...controls.oc({ tab: "address", c: "State", placeHolder: "State Code", name: "address.state_code", isRequired:true,fastpath:"states"}),
...controls.showData({ tab: "address", displaytype: "capital", data: "address.state_display"}),
...controls.displayText({ tab: "address", label: "Country",star:true}),
...controls.oc({ tab: "address", c: "Country", placeHolder: "Country Code", name: "address.country_code", isRequired:true,fastpath:"countries"}),
...controls.showData({ tab: "address", displaytype: "capital", data: "address.country_display"}),
...controls.displayText({ tab: "address", label: "Pincode",star:false}),
...controls.text({ tab: "address",  placeHolder: "", name: "address.pincode",isRequired:false,maxlength:6}),
...controls.displayText({ tab: "address", label: "",width:"col-sm-2"}),
]
,history:{
perPage: 10,
reportHeader: "Societies",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Society Code",accessor: "society_code",},
{Header: "Society",accessor: "society_display",},
{Header: "Metro Type",accessor: "metro_type",},
{Header: "Open Date",accessor: "open_date",type:'date'},
{Header: "Close Date",accessor: "close_date",type:'date'},
{Header: "Chairman Member Id",accessor: "chairman_member_id",},
{Header: "Secretary Employee Id",accessor: "secretary_employee_id",},
{Header: "Address Id",accessor: "address_id",},
{Header: "Society Active",accessor: "society_active",type:'tick'},
]}};
export default societies;